import { getPreviews } from '../utils';
import {
  Box,
  useMediaQuery, useStyleConfig,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import Actions from './components/Actions';
import Sections from './components/Sections';
import Header from './components/Header';
import Instructions from './components/Instructions';
import Index from './components/Notes';

const Preview = ({ props }) => {
  const stateProps = props.stateProps;
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const myData = stateProps.dataToSave.saved.resumes[resumeIndex];
  const variant = 'wrapper';
  const styles = useStyleConfig('Preview', { variant });
  props.stateProps.setRegenCS(false);
  const isDesktop = useMediaQuery('(min-width: 768px)', { ssr: false });
  const [isAccordion, setIsAccordion] = useState(true);
  if (myData) {
    const previews = getPreviews(myData, props.navSections);
    return (
      <Box sx={{...styles}} >
      <Box className='previewWrapper'>
          <Box className='actionWrapper' >
            <Actions myData={myData} props={props} previews={previews} styles={styles} isDesktop={isDesktop} />

          </Box>
        <Box className='sectionWrapper'>
          <Header props={props} />
          <Box className='sectionWrapperInterior'>
            <Instructions props={props} isAccordion={isAccordion} setIsAccordion={setIsAccordion} />
              <Sections  myData={myData} props={props} previews={previews} styles={styles} isDesktop={isDesktop}  />
            </Box>
        </Box>
      </Box>
      </Box>
    );

  } else {
    return null;
  }
};
export default Preview;
